import { Flex, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

const Insights = ({meeting}) => {
  const navigate = useNavigate()
  
  const handleClick = () => {
    const eventId = meeting.eventId
    navigate(`/transcripts-summaries/summary?eventId=${eventId}&tab=HIGH`)
  }

  return (
    <Flex
      flexDirection='column'
      border='0.5px solid rgba(28, 28, 28, 0.1)'
      boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
      borderRadius='12px'
      bg='white'
      p={5}
      flex={1}
      position='relative'
    >

      <Flex alignItems='center' mb='auto'>
        <Text color='#0F5257' fontWeight='800' fontSize='12px'>
          HIGHLIGHTS
        </Text>
      </Flex>

      <Flex mt={3} alignItems='center'>
        <Flex>
          <Text fontSize='30px'>
            ✨
          </Text>
        </Flex>
        
        <Flex ml={3} flexDirection='column'>
          <Flex>
            <Text onClick={() => handleClick()} cursor='pointer' color='brandTextBlack' fontWeight='600' lineHeight='22px' maxW='166px'>
              Explore {meeting.insight_count} Insights!
            </Text>  
          </Flex>

          <Flex mt={0} alignItems='center'>
            <Text color='#1C1C1C' fontSize='14px' letterSpacing='-0.01em' lineHeight='22px' opacity='0.7'>
              Dive In
            </Text>
          </Flex>
        </Flex>
      </Flex>

    </Flex>
  )
}

export default Insights